import { render, staticRenderFns } from "./DemandDetail.vue?vue&type=template&id=39817a3c&scoped=true"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"
import style0 from "./DemandDetail.vue?vue&type=style&index=0&id=39817a3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39817a3c",
  null
  
)

export default component.exports